import React from 'react';
import { Link, useParams } from 'react-router-dom';

function CogenDashboard() {
    const { id, plantName } = useParams(); // Get the cogen_id from the route

    const plantSections = [
        { name: 'Plant Officials', path: `/cogenplant-officials/${plantName}/${id}` },
        { name: 'Technical Information', path: `/technical-information/${plantName}/${id}` },
        { name: 'Performance Data', path: `/performance-data/${plantName}/${id}` },
    ];

    return (
        <div className="container-fluid my-5">
            <h2 className="text-center mb-4 dashboard-title">Cogeneration Plant Dashboard</h2>
            <div className="row g-4">
                {plantSections.map((section, index) => (
                    <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                        <Link to={section.path} className="text-decoration-none">
                            <div className="dashboard-card card text-center shadow-sm h-100">
                                <div className="card-body d-flex flex-column justify-content-center">
                                    <h5 className="card-title section-title">{section.name}</h5>
                                    <p className="card-text text-muted">View Details</p>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CogenDashboard;
